import { GTM_EVENTS, PAGE_TYPES } from './constants';
import { detectPageType } from './pageTypeDetector';

/**
 * Genera el objeto dl_start para el dataLayer
 * @param {string} pathname - window.location.pathname
 * @param {Object} productInfo - Info del producto (solo para page_type='product')
 * @param {string} productInfo.product_name - Nombre del producto
 * @param {string} productInfo.product_category - Categoría del producto
 * @returns {Object} - Objeto para pushear al dataLayer
 */
export const createDlStartEvent = (pathname, productInfo = null) => {
  const pageType = detectPageType(pathname);

  const dlStartEvent = {
    event: GTM_EVENTS.DL_START,
    page_type: pageType
  };

  // Solo agregar info de producto si es página de producto Y tenemos la info
  if (pageType === PAGE_TYPES.PRODUCT && productInfo) {
    dlStartEvent.product_name = productInfo.product_name || '';
    dlStartEvent.product_category = productInfo.product_category || '';
  }

  return dlStartEvent;
};
